<template>
  <div>
    <!--TODO: speed of particpant swaping isnt amazing, when everything is together, maybe revist and try events and local data -->
    <waiting-blue-bar
      :visible="$parent.$refs.sideBar.$refs.sidePart.canSeeWaitingList && showWaitPopup"
      :expanded="$parent.expanded"
      :wait-people="waitPeople"/>
    <webinar-blue-bar
      :visible="$parent.$refs.sideBar.$refs.sidePart.amImoderator && $parent.meetingInfo.webinar && !$parent.meetingInfo.options.includes('[webinarStarted=1]')"
      :wait-people="waitPeople"/>
    <b-row
      v-if="mode == 4"
      no-gutters
      class="limitedBlock">
      <span class="limitedBlockText">{{ $t('MEETING.LIMITED_MODE') }}</span>
    </b-row>
    <all-videos
      v-if="mode==0 || mode == 4"
    />
    <select-videos
      v-if="mode==1"
    />
    <speaker-videos
      v-if="mode==2"
    />
    <no-videos
      v-if="mode==3"
      :participants="$parent.$refs.sideBar.$refs.sidePart.participants.filter(i => !i.isWaiting)"
    />
    <all-videos-everyone
      v-if="mode==5"
    />
  </div>
</template>
<script>
import { ref, watch, onBeforeUnmount } from "@vue/composition-api"
import {getItem} from "../functions/storageManager"
import NoVideos from './VideoArea/NoVideos'
import AllVideos from './VideoArea/AllVideos'
import SelectVideos from './VideoArea/SelectVideos'
import SpeakerVideos from './VideoArea/SpeakerVideos'
import AllVideosEveryone from './VideoArea/AllVideosEveryone'
import WaitingBlueBar from './WaitingBlueBar'
import WebinarBlueBar from './WebinarBlueBar'
export default {
  name: 'VideoArea',
  components: {
    'no-videos': NoVideos,
    'all-videos': AllVideos,
    'select-videos': SelectVideos,
    'speaker-videos': SpeakerVideos,
    'all-videos-everyone': AllVideosEveryone,
    'waiting-blue-bar': WaitingBlueBar,
    'webinar-blue-bar': WebinarBlueBar
  },
  props: {
    mode: {
      type: Number,
      default: 5
    },
    streams: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const speaker_userId = ref('')
    const speakerList = ref([])
    const updater = ref({})
    const activeVideos = ref(0)
    const videoComponents = ref([])
    let debounce = null
    const packetLost = ref(
      {
        switchInterval: 120000,
        retrySwitchInterval: 600000,
        detectInterval: 30000,
        maxPacketLost: 2,
        packetLostDetected: null,
        lastPacketLostCheck: null,
      }
    )
    const showWaitPopup = ref(false)
    const waitPeople = ref([])
    const lastWaitPeople = ref(0)

    if(context.parent.meetingInfo.webinar)
      calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => { return i.rh && i.rh.substring(0,1) == "2" }))
    else
      calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => !i.isWaiting))
    //calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => !i.isWaiting))

    watch(() => context.parent.$refs.sideBar.$refs.sidePart.participants, (newParticipants, oldValue) => {
      if(context.parent.meetingInfo.webinar)
        calcVideoComp(newParticipants.filter(i => { return i.rh && i.rh.substring(0,1) == "2" }))
      else
        calcVideoComp(newParticipants.filter(i => !i.isWaiting))
      waitPeople.value = newParticipants.filter(i => i.isWaiting)
      if (waitPeople.value.length > 0 && lastWaitPeople.value != waitPeople.value.length) {
        showWaitPopup.value = true
        lastWaitPeople.value = waitPeople.value.length
      } else if (waitPeople.value.length == 0){
        showWaitPopup.value = false
        lastWaitPeople.value = waitPeople.value.length
      }
    })

    watch(activeVideos, value => {
      if(context.parent.meetingInfo.webinar)
        calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => { return i.rh && i.rh.substring(0,1) == "2" }))
      else
        calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => !i.isWaiting))
      
      if (context.parent.meetingInfo.waitingRoom == true) {
          waitPeople.value = context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => i.isWaiting)
        if (waitPeople.value.length > 0 && lastWaitPeople.value != waitPeople.value.length) {
          showWaitPopup.value = true
          lastWaitPeople.value = waitPeople.value.length
        } else if (waitPeople.value.length == 0){
          showWaitPopup.value = false
          lastWaitPeople.value = waitPeople.value.length
        }
      } else if (context.parent.meetingInfo.webinar == true){
        waitPeople.value = context.parent.$refs.sideBar.$refs.areAudience
      }
    })

    const actTime = ref(null)
    packetLost.value.lastPacketLostCheck = new Date().getTime()
    updater.value = setInterval(onTimer, 1000)
    if(context.parent.getItem('switchInterval') !== undefined) {
      packetLost.value.switchInterval = context.parent.getItem('switchInterval')
      packetLost.value.retrySwitchInterval = packetLost.value.switchInterval * 5
    }
    if(context.parent.getItem('detectInterval') !== undefined) {
      packetLost.value.detectInterval = context.parent.getItem('detectInterval')
    }
    if(context.parent.getItem('maxPacketLost') !== undefined) {
      packetLost.value.maxPacketLost = context.parent.getItem('maxPacketLost')
    }

    onBeforeUnmount(() => {
      clearInterval(updater.value)
    })

    function messageHandler (e) {
      speaker_userId.value = e
      let index = speakerList.value.findIndex( speaker => speaker == speaker_userId.value)
      if (index < 0) {
        speakerList.value.unshift(speaker_userId.value)
        if (speakerList.value.length > 3) {
          speakerList.value.pop()
        }
      } else if (index > 0){
        speakerList.value.splice(0, 0, speakerList.value.splice(index, 1)[0])
      }
    }

    function onTimer() {
      checkActiveStreams()
      if (context.parent.$refs.meetingControls) {
        context.parent.sendAudioLevel()
      }
    }

    async function checkActiveStreams(){
      let isOverloaded = false
      if (actTime.value != null && (new Date().getTime() - actTime.value) > 3000 ){
        //most probably overloaded pc/mobile
        if (props.mode < 3 || props.mode == 5) {
          //switch to limited mode
          context.parent.$refs.meetingControls.changeVideoLayoutOption(4)
        } else if (context.parent.$refs.meetingControls.camera){
          //turn off camera
          context.parent.$refs.meetingControls.camera = false
        } else if (props.mode == 4) {
          //switch to no video mode
          context.parent.$refs.meetingControls.changeVideoLayoutOption(3)
        }
        isOverloaded = true
        packetLost.value.lastPacketLostCheck = new Date().getTime()
      }
      actTime.value = new Date().getTime()
      await asyncForEach(props.streams, async (stream) => {
        await isActiveStream(stream).catch(e => console.log(e))
      }).catch(e => console.log(e))
      let filtered = props.streams.filter( value => value.active == true )
      if (activeVideos.value != filtered.length) {
        activeVideos.value = filtered.length
      }
      if(context.parent.$refs.meetingControls.desktop){
        activeVideos.value++;
      }
      if (!isOverloaded && (actTime.value - packetLost.value.lastPacketLostCheck) >= packetLost.value.detectInterval && activeVideos.value > 0) {
        packetLost.value.lastPacketLostCheck = new Date().getTime()
        packetLostDetection()
      }
    }

    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array).catch(e => console.log(e))
      }
    }

    async function isActiveStream(stream) {
      if (stream.media.getVideoTracks().length > 0 && stream.media.getVideoTracks()[0] != null) {
        let result = await context.parent.session.connection.getStats(stream.media.getVideoTracks()[0]).catch(e => console.log(e))
        result.forEach(report => {
          if( report.type === 'inbound-rtp') {
            if (report.bytesReceived > stream.bytesRecv) {
              stream.active = true
              if ((actTime.value - packetLost.value.lastPacketLostCheck) >= packetLost.value.detectInterval) {
                if (report.packetsReceived > stream.packetsRecv) {
                  stream.packetsLostPerc = ((report.packetsLost - stream.packetsLost) / (report.packetsReceived - stream.packetsRecv)) * 100
                } else {
                  stream.packetsLostPerc = (report.packetsLost / report.packetsReceived) * 100
                }
                console.log(stream.packetsLostPerc + " % for: " + report.ssrc)
              }
            } else {
              stream.clicked = false
              stream.active = false
              if (stream.popOut !== null) {
                 stream.popOut.close();
                 stream.popOut = null;
              }
            }
            stream.packetsLost = report.packetsLost
            stream.packetsRecv = report.packetsReceived
            stream.bytesRecv = report.bytesReceived
            if (stream.ssrc != report.ssrc) {
              console.warn("stream ssrc changed from: " + stream.ssrc + " to: " + report.ssrc)
              stream.ssrc = report.ssrc
              if(context.parent.meetingInfo.webinar)
                calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => { return i.rh && i.rh.substring(0,1) == "2" }))
              else
                calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants.filter(i => !i.isWaiting))
            }
            let videoComponent = videoComponents.value.find(videoComp => {
              if (videoComp.user && videoComp.user.wsParticipant) {
                let index = videoComp.user.wsParticipant.video.findIndex( video => video.ssrcAlt == stream.ssrc)
                if (index >= 0)
                  return videoComp
              }
              return null
            })
            /* if ((actTime.value - packetLost.value.lastPacketLostCheck) >= packetLost.value.detectInterval) {
              console.warn("ssrc: " + stream.ssrc + " is active:" + stream.active + " videoComponent attached: ", videoComponent)
            } */
          } else{
            if (!stream.active && stream.popOut !== null) {
              stream.popOut.close();
              stream.popOut = null;
            }
          }
        })

      }
    }

    function packetLostDetection() {
      if (packetLost.value.packetLostDetected == null) {
        let noPacketLost = props.streams.filter( value => value.active == true && value.packetsLostPerc < packetLost.value.maxPacketLost )
        if (noPacketLost.length == 0 && activeVideos.value > 1) {
          console.log("packet lost detected switch to limited")
          if (props.mode < 3) {
            context.parent.$refs.meetingControls.changeVideoLayoutOption(4)
          }
          packetLost.value.packetLostDetected = new Date().getTime()
        }
      } else if ((new Date().getTime() - packetLost.value.packetLostDetected) >= packetLost.value.switchInterval) {
        console.log("switch back to normal")
        if (props.mode > 2) {
          context.parent.$refs.meetingControls.changeVideoLayoutOption(0)
        }
        packetLost.value.switchInterval = packetLost.value.retrySwitchInterval //600000
        packetLost.value.packetLostDetected = null
      }
    }

    function calcVideoComp(newParticipants) {
      if (videoComponents.value.length > 0) {
        videoComponents.value.forEach( (videoComponent, index) => {
          if (videoComponent.user == null) {
            //remove video component without participant info
            videoComponents.value.splice(index, 1)
          } else {
            let index = newParticipants.findIndex((part) => { return part.id == videoComponent.user.id })
            if (index < 0) {
              videoComponents.value.splice(videoComponents.value.indexOf(videoComponent), 1)
            }
          }
        })
        newParticipants.forEach( participant => {
          let index = videoComponents.value.findIndex((videoComponent) => {
            return videoComponent.user && videoComponent.user.id == participant.id
          })
          let streams = props.streams
          streams.forEach( (item,i) => {
            if(item.source === "desktop"){
              streams.splice(i, 1);
              streams.unshift(item)
              //console.warn(`spliced ${item.ssrc} ${item.user.id} - ${item.user.firstName} to front`)
            }
          })
          let foundMedia = streams.filter((media) => {
            if (media.local && participant.isSelf) {
              return (media.active == true && ((media.source === "desktop" && context.parent.$refs.meetingControls.desktop == true) || (media.source === "camera" && context.parent.$refs.meetingControls.camera == true)))
            } else if (participant.wsParticipant){
              let foundMedia = participant.wsParticipant.video.find(vid => vid.ssrcAlt == media.ssrc)
              if (foundMedia) {
                return foundMedia.isOn == true
              }
            }
            return false
          })
          if (index < 0) {
            videoComponents.value.push({user: participant, clicked: false, media: foundMedia})
          } else {
            videoComponents.value[index].user = participant
            if (foundMedia.length != videoComponents.value[index].media.length) {
              if (videoComponents.value[index].user.wsParticipant) {
                let streamDesk = videoComponents.value[index].user.wsParticipant.video.find( video => video.cname.toLowerCase().includes("desk") || video.rtpname.toLowerCase().includes("desk"))
                if (streamDesk) {
                  let streamIndex = foundMedia.findIndex( video => video.ssrc == streamDesk.ssrcAlt)
                  if (streamIndex >= 0) {
                    console.log("move desk on top")
                    let stream = foundMedia[streamIndex]
                    foundMedia.splice(streamIndex,1)
                    foundMedia.unshift(stream)
                  }
                }
              }
              videoComponents.value[index].media = foundMedia
            }
            videoComponents.value.splice(index, 1, videoComponents.value[index])
          }
        })
      } else {
         newParticipants.forEach((participant) => {
          let foundMedia = props.streams.filter((media) => {
            if (media.local && participant.isSelf) {
              return (media.active == true && ((media.source === "desktop" && context.parent.$refs.meetingControls.desktop == true) || (media.source === "camera" && context.parent.$refs.meetingControls.camera == true)))
            } else if(participant.wsParticipant){
              let foundMedia = participant.wsParticipant.video.find(vid => vid.ssrcAlt == media.ssrc)
              if (foundMedia) {
                return foundMedia.isOn == true
              }
            }
            return false
          })
          videoComponents.value.push({user: participant, clicked: false, media: foundMedia})
         })
      }
      //create video component when video media is active but no participant found with such video ssrc
      if (context.parent.meetingInfo.webinar == false) {
        props.streams.forEach((media) => {
          if (media.active) {
            let found = false
            videoComponents.value.forEach( comp => {
              comp.media.forEach( med => {
                if (med.ssrc == media.ssrc)
                  found = true
              })
            })
            if (found == false && media.local != true) {
              console.log("found video stream dont belong to the participant!!!")
              videoComponents.value.push({user: null, clicked: false, media: [media]})
            }
          }
        })
        if (props.mode == 0) {
          let numberWithMedia = videoComponents.value.filter(comp => comp.media.length > 0).length
          videoComponents.value.forEach((comp, index) => {
            // move video component without media to the last position when its on position of active video components
            if (comp.media.length == 0 && index < numberWithMedia)
              videoComponents.value.splice(videoComponents.value.length-1, 0, videoComponents.value.splice(index, 1)[0])
          })
        }
      }
    }

    function getActiveVideoComponentMedia(videoComp) {
      return videoComp.media.filter( (cam) => {
        if (videoComp.user) {
          if (cam.local && videoComp.user.isSelf) {
            return (cam.active == true  && ((cam.source === "desktop" && context.parent.$refs.meetingControls.desktop == true) || (cam.source === "camera" && context.parent.$refs.meetingControls.camera == true)))
          } else if (videoComp.user.wsParticipant){
            let foundMedia = videoComp.user.wsParticipant.video.find(vid => vid.ssrcAlt == cam.ssrc)
            if (foundMedia) {
              return foundMedia.isOn == true
            }
          }
          return false
        } else {
          return cam.active == true
        }
      })
    }

    function computeVideoElementStyle(index, media) {
      if (index == 0) {
        if (getItem('cameraMirror') && media.local && media.source === 'camera')
          return {width: '100%', height: '100%', transform: "rotateY(180deg)"}
        else
          return {width: '100%', height: '100%', transform: "rotateY(0deg)"}
      } else if(index == 1) {
        return {top: '80%', left: '80%', width: '20%', height: '20%'}
      } else if(index == 2) {
        return {top: '80%', left: '60%', width: '20%', height: '20%'}
      } else if(index == 3) {
        return {top: '80%', left: '40%', width: '20%', height: '20%'}
      }
    }

    function moveToFirst(data, el) {
      data.forEach( (item,i) => {
        if(item === el){
          data.splice(i, 1);
          data.unshift(item)
        }
      })
    }

    function openPopup(stream) {
      let singleStream = getActiveVideoComponentMedia(stream)[0]
      let popUpWindow = window.open("", "_blank", 'width=640,height=360,resizable=1,scrollbars=0');
      let popup = document.getElementById("popup").cloneNode(true);
      popUpWindow.document.head.innerHTML = document.head.innerHTML; popUpWindow.onresize = resizeMe;

      for (var i=0; i<document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (sheet.href !== null) {
          var link = document.createElement("link");
          link.type = "text/css";
          link.rel = "stylesheet";
          link.href = sheet.href;
          popUpWindow.document.head.appendChild(link);
        }
      }
      var loop = setInterval(function() {
        if(popUpWindow.closed) {
          clearInterval(loop);
          singleStream.popOut = null;
        }
      }, 1000);
      let newBody = popUpWindow.document.body.appendChild(popup);
      newBody.style.display = "block";

      let newVideo = newBody.getElementsByTagName("video")[0]
      singleStream.popOut = popUpWindow
      newVideo.autoplay = true;
      newVideo.muted = true;
      newVideo.srcObject = singleStream.media;
    }

    function resizeMe(window) {
      let vid_w = window.target.outerWidth;
      let vid_h = vid_w / (16 / 9) + 55;
      clearTimeout(debounce);
      debounce = setTimeout(() => { window.target.resizeTo(vid_w, vid_h); clearTimeout(debounce); }, 200); }

    return {
      updater,
      videoComponents,
      activeVideos,
      speaker_userId,
      speakerList,
      messageHandler,
      packetLost,
      packetLostDetection,
      checkActiveStreams,
      actTime,
      getActiveVideoComponentMedia,
      calcVideoComp,
      openPopup,
      computeVideoElementStyle,
      moveToFirst,
      showWaitPopup,
      lastWaitPeople,
      waitPeople
    }
  }
}
</script>
<style scoped>
  .limitedBlock {
    position: absolute;
    padding: 1px 8px;
    border-radius: 4px;
    z-index: 300;
    background-color: #EF4539;
    left: 50%;
    width: auto;
    transform: translateX(-50%);
  }
  .limitedBlockText {
    font-size: 14px;
    color: #F8F8F8;
  }
  /*.waitBlock {
    position: absolute;
    padding: 4px 12px;
    border-radius: 4px;
    z-index: 300;
    background-color: #0072E5;
    left: 50%;
    width: auto;
    transform: translateX(-50%);
  }
  .waitBlockText {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/VideoArea.vue